// removed by extract-text-webpack-plugin
module.exports = {"separator":"StoriesStream__separator--4I88W","spinnerWrapper":"StoriesStream__spinnerWrapper--2mgmn","infinite":"StoriesStream__infinite--3rpZE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/StoriesStream/StoriesStream.css
// module id = ./src/components/Library/StoriesStream/StoriesStream.css
// module chunks = 2